"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/lib/space/style");

var _space = _interopRequireDefault(require("antd/lib/space"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.assign.js");

require("antd/lib/spin/style");

var _spin = _interopRequireDefault(require("antd/lib/spin"));

require("antd/lib/empty/style");

var _empty = _interopRequireDefault(require("antd/lib/empty"));

require("antd/lib/row/style");

var _row = _interopRequireDefault(require("antd/lib/row"));

require("antd/lib/col/style");

var _col = _interopRequireDefault(require("antd/lib/col"));

require("antd/lib/card/style");

var _card = _interopRequireDefault(require("antd/lib/card"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

require("./BoxSelect.less");

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["children", "icon", "className", "disabled", "value", "direction"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = BoxSelect;
/**
 * @name BoxSelect
 */

exports.default = _default;

function BoxSelect(_ref) {
  var children = _ref.children,
      defaultValue = _ref.defaultValue,
      _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? 3 : _ref$cols,
      loading = _ref.loading,
      onChange = _ref.onChange,
      className = _ref.className,
      itemBodyStyle = _ref.itemBodyStyle,
      itemBodyClassName = _ref.itemBodyClassName,
      itemWrapperStyle = _ref.itemWrapperStyle,
      itemWrapperClassName = _ref.itemWrapperClassName,
      activeItemBodyClassName = _ref.activeItemBodyClassName;

  var _useState = (0, _react.useState)(defaultValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var items = _react.default.Children.toArray(children);

  var span = Math.floor(24 / cols);
  var groups = [];

  for (var i = 0; i < items.length; i += cols) {
    groups.push(items.slice(i, i + cols));
  }

  var handleItemClick = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(item) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (item.props.disabled) {
                _context.next = 6;
                break;
              }

              setSelected(item.props.value);
              _context.t0 = onChange;

              if (!_context.t0) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return onChange(item.props.value);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleItemClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var content = items.length ? groups.map(function (group, gIndex) {
    return /*#__PURE__*/_react.default.createElement(_row.default, {
      key: gIndex,
      gutter: 16,
      className: "BoxSelect_row"
    }, group.map(function (item) {
      return /*#__PURE__*/_react.default.createElement(_col.default, {
        flex: "auto",
        xs: 24,
        sm: span,
        key: item.key || item.props.value,
        className: (0, _classnames.default)('BoxSelect_col', itemWrapperClassName),
        style: itemWrapperStyle
      }, /*#__PURE__*/_react.default.createElement(_card.default, {
        className: (0, _classnames.default)('BoxSelect_item-wrapper', {
          'BoxSelect_item-wrapper--active': item.props.value === selected,
          'BoxSelect_item-wrapper--disabled': item.props.disabled
        }, [activeItemBodyClassName, item.props.value === selected], itemBodyClassName),
        bodyStyle: (0, _objectSpread2.default)({
          width: '100%',
          height: '100%'
        }, itemBodyStyle),
        hoverable: true,
        onClick: function onClick() {
          return handleItemClick(item);
        }
      }, item));
    }));
  }) : /*#__PURE__*/_react.default.createElement(_empty.default, {
    image: _empty.default.PRESENTED_IMAGE_SIMPLE
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('BoxSelect', className)
  }, loading ? /*#__PURE__*/_react.default.createElement(_spin.default, {
    className: "BoxSelect_spinner"
  }, content) : content);
}

BoxSelect.Item = function (_ref3) {
  var children = _ref3.children,
      icon = _ref3.icon,
      className = _ref3.className,
      disabled = _ref3.disabled,
      value = _ref3.value,
      _ref3$direction = _ref3.direction,
      direction = _ref3$direction === void 0 ? 'horizontal' : _ref3$direction,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);

  if (!value) {
    throw new Error('BoxSelect.Item must have value parameter set');
  }

  return /*#__PURE__*/_react.default.createElement(_space.default, Object.assign({
    size: 10,
    align: direction === 'vertical' ? 'start' : 'center',
    direction: direction,
    className: (0, _classnames.default)('BoxSelect_item', {
      'BoxSelect_item--disabled': disabled
    }, className),
    value: value
  }, rest), icon ? /*#__PURE__*/_react.default.createElement("div", {
    className: "BoxSelect_item-icon"
  }, icon, " ") : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "BoxSelect_item-content"
  }, children));
};